import type { ChatMessage } from '../hooks/useChat'
import { formatBytes, KIND_LABELS } from '../lib/documents'
import { Markdown } from './Markdown'

const time = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' })

export function MessageBubble({ message }: { message: ChatMessage }) {
  const isUser = message.role === 'user'
  const attachments = message.attachments ?? []

  return (
    <article className={`message message--${message.role}`}>
      <div className="message__meta">
        <span className="message__author">{isUser ? 'You' : 'ContractIQ'}</span>
        <time dateTime={new Date(message.timestamp).toISOString()}>
          {time.format(message.timestamp)}
        </time>
      </div>
      <div className="message__body">
        {attachments.length > 0 && (
          <ul className="message__attachments" aria-label="Attached documents">
            {attachments.map((file) => (
              <li key={file.path} className="message__attachment">
                <span className={`attachment__badge attachment__badge--${file.kind}`} aria-hidden>
                  {KIND_LABELS[file.kind]}
                </span>
                <span className="message__attachment-name" title={file.path}>
                  {file.name}
                </span>
                <span className="message__attachment-size">{formatBytes(file.bytes)}</span>
              </li>
            ))}
          </ul>
        )}
        {isUser ? <p>{message.text}</p> : <Markdown text={message.text} />}
      </div>
    </article>
  )
}
